import { ReactNode, useMemo } from 'react';

// material-ui
import AppBar, { AppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';

// project imports
import HeaderContent from './HeaderContent';

// ==============================|| COMPANY SELECTION HEADER ||============================== //

export default function CompanySelectionHeader() {
  // header content
  const headerContent = useMemo(() => <HeaderContent />, []);

  // simplified header without drawer controls
  const mainHeader: ReactNode = <Toolbar>{headerContent}</Toolbar>;

  // app-bar params - full width since no drawer
  const appBar: AppBarProps = {
    position: 'fixed',
    color: 'inherit',
    elevation: 0,
    sx: {
      borderBottom: '1px solid',
      borderBottomColor: 'divider',
      zIndex: 1200,
      width: '100%'
    }
  };

  return <AppBar {...appBar}>{mainHeader}</AppBar>;
}
